module.exports = __webpack_public_path__ + "img/support.f449307b.png";